module.exports = __webpack_public_path__ + "img/cat.b742e5fa.jpg";